/**
 * Whole-euro amounts as every acquisition form types and sends them. The
 * acquisition contracts take JSON integers only, so these helpers group and
 * ungroup thousands for the eye and never round or otherwise reshape a figure.
 */
const groupThousands = (digits: string) =>
  digits.replace(/\B(?=(\d{3})+(?!\d))/g, '.');

/** Like the public funnels, input stops at nine digits (€999.999.999). */
const MAX_AMOUNT_DIGITS = 9;

export const acquisitionAmountInput = (raw: string) =>
  groupThousands(raw.replace(/\D/g, '').slice(0, MAX_AMOUNT_DIGITS));

/** `null` when the display text is not a positive whole-euro amount. */
export const acquisitionAmountToNumber = (display: string): number | null => {
  const digits = display.replace(/\D/g, '');
  if (!digits) return null;

  const value = Number(digits);
  return value > 0 ? value : null;
};

const euroFormatter = new Intl.NumberFormat('it-IT', {
  maximumFractionDigits: 0,
});

/** How a confirmed amount reads back to the operator in the review. */
export const acquisitionEuro = (amount: number) =>
  `€ ${euroFormatter.format(amount)}`;
